<template>
    <div>
        <table class="table table-sm">
            <thead>
                <tr>
                    <th>Model Adı</th>
                    <th>Geçerli Fiyat Başlangıç Tarihi</th>
                    <th>Geçerli Fiyat</th>
                    <th>Yeni Fiyat Başlangıç Tarihi</th>
                    <th>Yeni Fiyat</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in c_value" :key="index">
                    <td class="text-nowrap">{{item.Name}}</td>
                    <td>{{item.CurrentEffectiveDate}}</td>
                    <td>{{item.CurrentPrice}}</td>
                    <td><flat-pickr v-model="item.EffectivePriceDate" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Tarih Seçiniz"/></td>
                    <td><input class="form-control" v-model="item.Price"/></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment" 
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
export default {
    components:{
        flatPickr
    },
    props:{
        value:Array
    },
    computed:{
        c_value(){
            this.value.forEach(item => {
                this.$set(item,"TireReferenceModelId",item.Id)
                this.$set(item,"EffectivePriceDate",moment(Date.now()).format("YYYY-MM-DD"))
                this.$set(item,"Price",Number(item.CurrentPrice.replace(".",'').replace(',','.')))
            })
            return this.value
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>